export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-pagination@1.17.0@rc-pagination/es/index.js
// module id = 1356
// module chunks = 0 1